<template>
  <vs-popup :title="$t(title)" :active.sync="showPopup" id="AlertDialog" :class="size">
    <div class="flex items-center gap-2">
      <feather-icon v-if="!!messageIcon" :icon="messageIcon" style="width: 18px; height: 18px" />
      <!-- UiUtil.alertDialog / confirmDialog 는 일반 텍스트로 표시한다 (줄바꿈 유지) -->
      <span v-if="plain" style="white-space: pre-line">{{ $t(message) }}</span>
      <span v-else v-html="$t(message)"> </span>
    </div>
    <vs-row>
      <vs-col class="mt-4 flex" vs-align="center" :vs-justify="!!btnPosition ? btnPosition : 'flex-end'">
        <vs-button v-if="useConfirm" class="mr-4" color="secondary" :type="confirmBtnStyle.type || 'filled'" :style="confirmBtnStyle.style" @click="handleClickConfirm">
          <img v-if="!!confirmBtnStyle.icon && confirmBtnStyle.icon.type && confirmBtnStyle.icon.type === 'image'" :src="require(`@/assets/images/icon/${confirmBtnStyle.icon.name}`)" />
          <feather-icon v-else-if="!!confirmBtnStyle.icon && confirmBtnStyle.icon.type && confirmBtnStyle.icon.type === 'feather'" :icon="confirmBtnStyle.icon.name" style="width: 18px; height: 18px" />
          <div>
            {{ $t(confirmBtn) }}
          </div>
        </vs-button>
        <vs-button color="secondary" :type="cancelBtnStyle.type || 'border'" :style="cancelBtnStyle.style" @click="handleClickClose">
          <img v-if="!!cancelBtnStyle.icon && cancelBtnStyle.icon.type && cancelBtnStyle.icon.type === 'image'" :src="require(`@/assets/images/icon/${cancelBtnStyle.icon.name}`)" />
          <feather-icon v-else-if="!!cancelBtnStyle.icon && cancelBtnStyle.icon.type && cancelBtnStyle.icon.type === 'feather'" :icon="cancelBtnStyle.icon.name" style="width: 18px; height: 18px" />
          <div>
            {{ $t(cancelBtn) }}
          </div>
        </vs-button>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
export default {
  data() {
    return {
      showPopup: false,
      useConfirm: false,
      title: "",
      messageIcon: null,
      message: "",
      confirmBtn: "확인",
      cancelBtn: "닫기",
      confirmFunction: null,
      cancelFunction: null,
      size: null,
      btnPosition: null,
      confirmBtnStyle: {
        type: null,
        icon: null,
        style: null,
      },
      cancelBtnStyle: {
        type: null,
        icon: null,
        style: null,
      },
      plain: false,
      // UiUtil.alertDialog / confirmDialog 가 결과를 받는 콜백. 어떤 방식으로 닫혀도 한 번만 호출한다
      onSettle: null,
    };
  },
  watch: {
    showPopup(value) {
      // 닫기(X) 버튼이나 바깥 영역 클릭으로 닫힌 경우는 취소로 처리한다
      if (!value) this.settle(false);
    },
  },
  mounted() {
    window.addEventListener("customAlert", this.openCustomAlert);
  },
  beforeDestroy() {
    window.removeEventListener("customAlert", this.openCustomAlert);
  },
  methods: {
    openCustomAlert(event) {
      const { title, messageIcon, message, useConfirm, confirmBtn, cancelBtn, confirmFunction, cancelFunction, size, btnPosition, confirmBtnStyle, cancelBtnStyle, plain, onSettle } = event.detail;

      // 앞의 창이 열린 채로 새 창이 덮어쓰면, 앞의 창은 취소된 것으로 결과를 돌려준다
      this.settle(false);

      this.plain = !!plain;
      this.onSettle = onSettle || null;

      this.title = title;
      this.messageIcon = messageIcon || null;
      this.message = message;

      this.useConfirm = useConfirm || false;
      this.confirmBtn = confirmBtn || "확인";
      this.cancelBtn = cancelBtn || "닫기";

      this.confirmFunction = confirmFunction || null;
      this.cancelFunction = cancelFunction || null;

      this.size = size || null;
      this.btnPosition = btnPosition || null;
      this.confirmBtnStyle = confirmBtnStyle || {};
      this.cancelBtnStyle = cancelBtnStyle || {};

      this.showPopup = true;
    },
    handleClickConfirm() {
      if (this.confirmFunction) this.confirmFunction();
      this.settle(true);

      this.showPopup = false;
      // 제목·문구는 닫히는 애니메이션 동안 남겨 둔다 (바로 비우면 빈 창이 잠깐 보인다).
      // 다음에 열 때 openCustomAlert 가 모든 값을 다시 채우므로, 실행 함수만 지운다.
      this.confirmFunction = null;
      this.cancelFunction = null;
    },
    handleClickClose() {
      if (this.cancelFunction) this.cancelFunction();
      this.settle(false);

      this.showPopup = false;
      // 제목·문구는 닫히는 애니메이션 동안 남겨 둔다 (바로 비우면 빈 창이 잠깐 보인다).
      // 다음에 열 때 openCustomAlert 가 모든 값을 다시 채우므로, 실행 함수만 지운다.
      this.confirmFunction = null;
      this.cancelFunction = null;
    },
    settle(result) {
      const onSettle = this.onSettle;
      this.onSettle = null;
      if (onSettle) onSettle(result);
    },
  },
};
</script>

<style lang="scss" scoped>
#AlertDialog::v-deep {
  &.con-vs-popup {
    // 처리중(LoadingDialog, 9999999) 위에 떠야 로딩 중에 띄운 알림/확인도 누를 수 있다
    z-index: 10000000;
  }
}
#AlertDialog.small::v-deep {
  .vs-popup {
    width: 300px;
  }
}
</style>
